import React from 'react';

    function ResourcesPage() {
      return (
        <div class="res">
            <ul>
                <li><a href="https://ospi.k12.wa.us/policy-funding/child-nutrition" target="_blank"><i class="fa-solid fa-arrow-right fa-xs"></i> Child Nutrition</a></li>
                <li><a href="https://www.fns.usda.gov/cacfp" target="_blank"><i class="fa-solid fa-arrow-right fa-xs"></i> CACFP</a></li>
                <li><a href="https://www.kidkare.com/" target="_blank"><i class="fa-solid fa-arrow-right fa-xs"></i> KidKare</a></li>
            </ul>
        </div>
      );
    }

    export default ResourcesPage;